class EventBus {
  events: Map<any, any>;
  constructor() {
    this.events = new Map(); // 存储事件及其回调函数
  }

  // 订阅事件
  on(eventName: string, callback: () => void) {
    if (!this.events.has(eventName)) {
      this.events.set(eventName, []);
    }
    this.events.get(eventName).push(callback);
    return () => this.off(eventName, callback); // 返回取消订阅函数
  }

  // 发布事件
  emit(eventName: string, payload?: any) {
    if (this.events.has(eventName)) {
      this.events.get(eventName).forEach((callback: (arg0: any) => any) => callback(payload));
    }
  }

  // 取消订阅
  off(eventName: string, callback: () => void) {
    if (this.events.has(eventName)) {
      const callbacks = this.events.get(eventName);
      const index = callbacks.indexOf(callback);
      if (index !== -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  // 清除所有订阅
  clear() {
    this.events.clear();
  }
}

// 创建全局单例
export const eventBus = new EventBus();